import { ConfirmDialog } from '@/shared/components';
import type { CreateInvoiceBlockRequest, InvoiceBlockResponse } from '@/shared/api';
import { InvoiceBlockEditDialog } from './InvoiceBlockEditDialog';

interface Props {
  editOpen: boolean;
  onEditOpenChange: (open: boolean) => void;
  /** `null` = neuer Posten, sonst der zu bearbeitende. */
  editing: InvoiceBlockResponse | null;
  deleting: InvoiceBlockResponse | null;
  onDeletingChange: (block: InvoiceBlockResponse | null) => void;
  propertyCurrency: string;
  saving: boolean;
  deletePending: boolean;
  onSubmit: (values: CreateInvoiceBlockRequest) => void;
  onConfirmDelete: (block: InvoiceBlockResponse) => void;
}

/** Die beiden Overlays der Sektion — bearbeiten und entfernen. */
export function InvoiceBlocksDialogs({
  editOpen,
  onEditOpenChange,
  editing,
  deleting,
  onDeletingChange,
  propertyCurrency,
  saving,
  deletePending,
  onSubmit,
  onConfirmDelete,
}: Props) {
  return (
    <>
      <InvoiceBlockEditDialog
        open={editOpen}
        onOpenChange={onEditOpenChange}
        block={editing}
        propertyCurrency={propertyCurrency}
        saving={saving}
        onSubmit={onSubmit}
      />

      <ConfirmDialog
        open={!!deleting}
        onOpenChange={(open) => {
          if (!open) onDeletingChange(null);
        }}
        title="Posten entfernen?"
        description={
          deleting
            ? `„${deleting.label}" wird aus zukünftigen Rechnungen entfernt. Bereits erzeugte Rechnungen bleiben unverändert.`
            : ''
        }
        confirmLabel="Entfernen"
        loading={deletePending}
        onConfirm={() => {
          if (deleting) onConfirmDelete(deleting);
        }}
      />
    </>
  );
}
